// @ts-nocheck

import { createContext, useContext } from 'react';

import { type SafeAreaInsetValue } from '../utils/layout';

type ViewportContextProps = {
  fontSize: number;
  navbarHeight: number;
  tabbarHeight: number;
  safeAreaInset: SafeAreaInsetValue;
  width: number;
  height: number;
  orientation?: number;
  ratio?: number;
  domNodeRef?: { current: null | HTMLElement };
};

export const ViewportContext = createContext<ViewportContextProps>({
  fontSize: 14,
  navbarHeight: 0,
  tabbarHeight: 0,
  safeAreaInset: { bottom: 0 },
  width: 0,
  height: 0,
});

export const useViewportContext = () => useContext(ViewportContext);
